<template lang="pug">
md-layout
  md-layout(md-flex='100', md-align='center', v-if='inQueue || failed')
    md-theme(md-name='blue')
      span.alert(v-if='inQueue')
        md-icon.md-warn(md-iconset="fa fa-exclamation-circle")
        | This content is in queue for encoding. Please check back soon.
      span.alert(v-if='failed')
        md-icon.md-warn(md-iconset="fa fa-exclamation-triangle")
        | This content failed to encode.
  md-layout.containerPreview(v-else)
    md-layout.video-preview(md-flex='100')
      .md-headline Preview

    md-layout(:md-gutter='24', md-flex='100')
      md-layout(md-flex='50', md-flex-small='100')
        video(v-if='videoSource !== ""', controls)
          source(:src='videoSource', :type='getVideoType(mediaItem)', :poster='getVideoPoster(mediaItem)')
        md-layout(md-flex='100')
          md-layout(md-flex='100').md-caption.title
            div {{ mediaItem.name }}
            div.md-caption.subtitle {{ mediaItem.name }}
      md-layout(md-flex='50', md-flex-small='100')
        md-layout(md-column)
          .md-subheading Encoded Versions
          md-list.full-width.md-triple-line
            md-list-item(v-for='(rendition, renditionKey) in mediaItem.renditions', v-if='rendition.length > 0' :key='renditionKey')
              md-avatar
                md-image(:md-src="mediaItem.poster[renditionKey].startsWith('http') ? mediaItem.poster[renditionKey] : '//' + imageBucketName + '/' + mediaItem.poster[renditionKey]")
              .md-list-text-container
                span {{ renditionKey }}
                span {{ rendition[0].type }}
                span {{ rendition[0].width }}x{{ rendition[0].height }}
              md-divider.md-inset
    md-layout#thumbnails(md-flex='100', v-if='mediaItem.thumbnails')
      .md-subheading.thumbnails Thumbnails
      div(v-for='thumbnail in mediaItem.thumbnails.default')
        img.thumbnail(:src="thumbnail.startsWith('http') ? thumbnail : '//' + imageServerBase + '/' + thumbnail")

</template>

<script>
  import videoMixin from '../videomixins';

  export default {
    mixins: [videoMixin],
    props: ['mediaItem'],
    data() {
      return {
        imageServerBase: process.env.THUMBNAIL_BASE_URL,
        imageBucketName: process.env.IMAGES_BUCKET_NAME,
        videoSource: '',
      };
    },
    computed: {
      inQueue() {
        return ['new', 'requested'].includes(this.mediaItem.encodingStatus);
      },
      failed() {
        return ['failed', 'unencoded'].includes(this.mediaItem.encodingStatus);
      }
    },
    updated(){
      this.videoSource = videoMixin.methods.getVideoSource(this.mediaItem);
      const video = document.createElement('video');
      video.src = this.videoSource;
      video.preload = 'metadata';
      video.onloadedmetadata = () => {
        this.$emit('videoDuration', video.duration );
      }
    },
  };
</script>

<style lang="scss" scoped>
  .alert {
    font-size: 1.5em;
    .md-icon {
      margin-right: 10px;
      margin-top: -5px;
      font-size: 1.3em;
    }
  }
  .md-headline {
    margin-bottom: 10px;
  }
  .md-caption.title {
    line-height: 130%;
    display: block;
    margin-top: 10px;
    font-size: 20px;
    color: #000;
  }
  .md-caption.subtitle {
    font-size: 14px;
  }
  .md-subheading.thumbnails {
    margin: 45px 0 15px 0;
    width: 100%;
  }
  .full-width {
    width: 100%;
  }
  #thumbnails {
    display: none;
  }
  .thumbnail {
    max-width: 200px;
    margin-right: 5px;
    margin-bottom: 5px;
  }
  .video-preview {
    .md-caption {
      margin-top: 10px;
      font-size: 1.1em;
    }
    @media all and (max-width: 1200px) {
      margin-bottom: 35px;
    }
  }
  .containerPreview {
    margin-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/mediaItem/MediaItemPreview.vue